import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { DrawerService } from './services/drawer.service';
import { TitleService } from './services/title.service';

@Component({
  selector: 'main[app-root]',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  constructor(
    private titleService: TitleService,
    private router: Router,
    private dialog: MatDialog,
    private drawerService: DrawerService
  ) {}

  ngOnInit() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.titleService.setCanonicalURL(event.urlAfterRedirects);
        this.dialog.closeAll();
        this.drawerService.closeMenu();
        this.drawerService.closeCart();
      });
  }
}
